import {
  Workbook
} from 'exceljs';
import * as fs from 'file-saver';
import moment from "moment";

const exportExcel = (datos, fecha) => {

  let fechaShort = moment(fecha, 'DD/MM/YYYY').format('DD-MMMM-YYYY');
  fecha = moment(fecha, 'DD/MM/YYYY').format('DD [de] MMMM [del] YYYY');


  let datosObj = [];

  datos.forEach((x, index) => {

    if (x.PAQUETES.InfoPaquetes && x.PAQUETES.InfoPaquetes.length > 1) {
      // console.log("multipieza", x.REFERENCIA, x.PAQUETES.InfoPaquetes);
      x.PAQUETES.InfoPaquetes.forEach((y, indey,arr) => {
        // console.log(y);
        // console.log( y[indey]);
        datosObj.push({
          destinatario_nombre: x.DESTINATARIO.nombre,
          destinatario_telefono: x.DESTINATARIO.telefono,
          detalle_envio: x.DETALLE_ENVIO,
          direccion_envio: x.DIRECCION[0].direccion + ' ' + x.DIRECCION[0]
            .municipio + ' ' + x.DIRECCION[0].estado + ' ' + x.DIRECCION[0]
              .colonia + ' ' + x.DIRECCION[0].codigopostal + ' ' + x.DIRECCION[
                0].pais,
          estado: x.ESTADO,
          fecha: x.FECHA,
          descripcion_paquete: x.PAQUETES.Descripcion,
          referencia: x.REFERENCIA,
          remitente_nombre: x.REMITENTE.nombre,
          sucursal: x.SUCURSAL,
          tipo_servicio: x.TIPO_SERVICIO + ` MULTIPIEZA (${indey+1} de ${arr.length})`,
          usuario: x.USUARIO,
          guia: y.guia,
          pesokg: y.pesokg,
          pesovol: y.pesovol,
          alto_paquete: y.alto,
          ancho_paquete: y.ancho,
          largo_paquete: y.largo
        })
      });

    } else

      datosObj.push({
        destinatario_nombre: x.DESTINATARIO.nombre,
        destinatario_telefono: x.DESTINATARIO.telefono,
        detalle_envio: x.DETALLE_ENVIO,
        direccion_envio: x.DIRECCION[0].direccion + ' ' + x.DIRECCION[0]
          .municipio + ' ' + x.DIRECCION[0].estado + ' ' + x.DIRECCION[0]
            .colonia + ' ' + x.DIRECCION[0].codigopostal + ' ' + x.DIRECCION[
              0].pais,
        estado: x.ESTADO,
        fecha: x.FECHA,
        descripcion_paquete: x.PAQUETES.Descripcion,
        referencia: x.REFERENCIA,
        remitente_nombre: x.REMITENTE.nombre,
        sucursal: x.SUCURSAL,
        tipo_servicio: x.TIPO_SERVICIO,
        usuario: x.USUARIO,
        guia: x.PAQUETES.InfoPaquetes ? x.PAQUETES.InfoPaquetes[0].guia : x.PAQUETES.InfoMensajeria[0].guia,
        pesokg: x.PAQUETES.InfoPaquetes ? x.PAQUETES.InfoPaquetes[0].pesokg : x.PAQUETES.InfoMensajeria[0].pesokg,
        pesovol: x.PAQUETES.InfoPaquetes ? x.PAQUETES.InfoPaquetes[0].pesovol : x.PAQUETES.InfoMensajeria[0].pesovol,
        alto_paquete: x.PAQUETES.InfoPaquetes ? x.PAQUETES.InfoPaquetes[0].alto : '',
        ancho_paquete: x.PAQUETES.InfoPaquetes ? x.PAQUETES.InfoPaquetes[0].ancho : '',
        largo_paquete: x.PAQUETES.InfoPaquetes ? x.PAQUETES.InfoPaquetes[0].largo : ''
      })
  });

  // console.log(datosObj);


  // console.info(datosObj, fecha);
  let workbook = new Workbook();
  let worksheet = workbook.addWorksheet('HistorialEnvios_' + fechaShort);



  let header = worksheet.addRow(['Envíos del día ' + fecha]);
  header.eachCell((cell, number) => {

    cell.font = {
      bold: true,
      size: 20,
      color: { argb: '000000' },
    };
  });
  worksheet.mergeCells(`A1:D1`);

  let row = worksheet.addRow(['Referencia', 'Tipo Servicio', 'Guia', 'Peso KG', 'Peso Vol.', 'Alto Paquete', 'Ancho Paquete', 'Largo Paquete', 'Remitente', 'Nombre Destinatario', 'Telefono Destinatario', 'Detalle Envio', 'Destino', 'Estatus Envio', 'Fecha Envio']);

  row.eachCell((cell, number) => {
    cell.fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: '0000ff' },
      bgColor: { argb: '' },
    };
    cell.font = {
      bold: true,
      size: 12,
      color: { argb: 'ffffff' },
    };
    cell.alignment = {
      vertical: 'middle',
      horizontal: 'center',
      wrapText: true
    };
  });

  datosObj.forEach(el => {
    let rowData = worksheet.addRow([el.referencia, el.tipo_servicio, el.guia, el.pesokg, el.pesovol, el.alto_paquete, el.ancho_paquete, el.largo_paquete, el.remitente_nombre, el.destinatario_nombre, el.destinatario_telefono, el.detalle_envio, el.direccion_envio, el.estado, el.fecha]);
    rowData.eachCell((cell, number) => {
      cell.alignment = {
        vertical: 'middle',
        horizontal: 'center',
      };
    });

  });

  worksheet.columns.forEach((column) => {
    const lengths = column.values.map((v) => {
      return v?.toString().length || 0;
    });
    const maxLength = Math.max(
      ...lengths.filter((v) => typeof v === 'number')
    );
    column.width = maxLength;
  });


  workbook.xlsx.writeBuffer().then((data) => {
    let blob = new Blob([data], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
    fs.saveAs(blob, 'HistorialEnvios-' + fechaShort + '.xlsx');
  });
}

const ValidaEntradaTeclado = (event, expresion) => {
  if (!expresion.test(event.key)) return event.preventDefault();
};

const CapitalizaPalabra = texto => {
  return texto
    .toLowerCase()
    .split(" ")
    .map(palabra => (palabra.length > 0 ? palabra[0].toUpperCase() +
      palabra.substr(1) : ""))
    .join(" ");
};

const FormatoGuia = guia => {
  return guia.replace(/([0-9]{4})(\B)/g, "$1 ");
};

/*
 Ejemplo1 FormatoMoneda.format(200) Salida: $200.00
 Ejemplo2 FormatoMoneda.format(20350.50) Salida: $20,350.50
*/
const FormatoMoneda = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2,
});



export {
  ValidaEntradaTeclado,
  CapitalizaPalabra,
  FormatoGuia,
  FormatoMoneda,
  exportExcel
};
